import { combineReducers } from 'redux';
import {
  SERVICES_TAB,
  SET_ACTIVE_BARBER,
  SET_PRODUCT_BRAND_ID,
  SET_PRODUCT_CATEGORY_ID,
  SET_PRODUCT_SEARCH,
  SET_SERVICE_SEARCH,
  RESET_TAB,
  SELECT_TAB,
} from './constants';
import { SALE_CASH_CHARGE } from '../payment/constants';

const activeBarberId = (state = null, { type, payload }) => {
  switch (type) {
    case SET_ACTIVE_BARBER:
      return payload || null;
    default:
      return state;
  }
};

const charge = (state = {}, { type, payload }) => {
  switch (type) {
    case SALE_CASH_CHARGE:
      return payload;
    default:
      return state;
  }
};

const categoryId = (state = null, { type, payload }) => {
  switch (type) {
    case SET_PRODUCT_CATEGORY_ID:
      return payload || null;
    default:
      return state;
  }
};

const brandId = (state = null, { type, payload }) => {
  switch (type) {
    case SET_PRODUCT_BRAND_ID:
      return payload || null;
    default:
      return state;
  }
};

const productSearch = (state = '', { type, payload }) => {
  switch (type) {
    case SET_PRODUCT_SEARCH:
      return payload || '';
    default:
      return state;
  }
};

const serviceSearch = (state = '', { type, payload }) => {
  switch (type) {
    case SET_SERVICE_SEARCH:
      return payload || '';
    default:
      return state;
  }
};

const productFilters = combineReducers({
  categoryId,
  brandId,
  productSearch,
});

const tab = (state = SERVICES_TAB, { type, payload }) => {
  switch (type) {
    case SELECT_TAB:
      return payload;
    case RESET_TAB:
      return SERVICES_TAB;
    default:
      return state;
  }
};

const saleReducer = combineReducers({
  activeBarberId,
  charge,
  productFilters,
  serviceSearch,
  tab,
});

export default saleReducer;
